<template>
    <div class="tabs-sticky marginBottom20" ref="tabsSticky">
        <div class="tabs-wrapper">
            <div role="tablist" ref="tabListRef" @keydown="handleKeyNavigation">
                <button
                    v-for="tab in filteredTabs"
                    :key="tab.id"
                    class="nav-link"
                    :class="{ active: currentTab == tab.id }"
                    :id="`${tab.id}-tab`"
                    data-toggle="tab"
                    :data-target="`#${tab.id}-panel`"
                    type="button"
                    role="tab"
                    :tabindex="currentTab === tab.id ? 0 : -1"
                    :aria-controls="tab.id ? `${tab.id}-panel` : undefined"
                    :aria-selected="currentTab == tab.id"
                    @click.prevent="currentTab = tab.id"
                >
                    {{ tab.label }}
                </button>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const emit = defineEmits(['emitCurrentTab', 'filterTabs']);

const props = defineProps({
    arrayValue: {
        type: Array,
        required: true,
    },
});

const tabListRef = ref(null);
const currentTab = ref('');
const tabsSticky = ref(null);

const filteredTabs = computed(() => {
    emit(
        'filterTabs',
        props.arrayValue.filter((tab) => tab.show)
    );
    return props.arrayValue.filter((tab) => tab.show);
});

const tabStickyTop = () => {
    var topOffset = 0;

    if ($(window).width() < 992) {
        if (isNaN($('.fixed-banner-container').outerHeight())) {
            topOffset = $('.top_nav.mobile').outerHeight();
        } else {
            topOffset = $('.fixed-banner-container').outerHeight() + $('.top_nav.mobile').outerHeight();
        }
    } else {
        if (isNaN($('.fixed-banner-container').outerHeight())) {
            topOffset = $('.top_nav.desktop').outerHeight();
        } else {
            topOffset = $('.fixed-banner-container').outerHeight() + $('.top_nav.desktop').outerHeight();
        }
    }

    tabsSticky.value.style.top = `${topOffset}px`;
};

const handleKeyNavigation = (e) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        const tabButtons = tabListRef.value.querySelectorAll('[role="tab"]');
        const tabCount = tabButtons.length;

        const currentFocusIndex = Array.from(tabButtons).findIndex((tab) => tab === document.activeElement);

        const direction = e.key === 'ArrowRight' ? 1 : -1;
        const newIndex = (currentFocusIndex + direction + tabCount) % tabCount;

        // currentTab.value = filteredTabs.value[newIndex].id;

        tabButtons[newIndex].focus();
        e.preventDefault();
    }
};

watch(currentTab, () => {
    const routeObject = {
        query: { ...route.query, tab: currentTab.value },
    };

    if (route.hash != null && currentTab.value == 'overview') {
        routeObject.hash = route.hash;
    } else {
        router.replace({
            ...route,
            hash: null,
            query: { ...route.query, tab: currentTab.value },
        });
    }

    router.replace(routeObject).then(() => {
        tabStickyTop();
        emit('emitCurrentTab', currentTab.value);

        if (route.hash != null && currentTab.value == 'overview') {
            const currentHash = routeObject.hash.replace('#', '');
            setTimeout(() => {
                const rightColPosition = document.querySelector('.right_col')
                    ? document.querySelector('.right_col').getBoundingClientRect().top + window.scrollY
                    : 0;
                const stickyNavHeight = $('.tabs-sticky').outerHeight();

                const element = document.getElementById(currentHash);
                if (element) {
                    const elementPosition = element.getBoundingClientRect().top + window.scrollY - rightColPosition - stickyNavHeight - 10;

                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth',
                    });
                }
            }, 500);
        }
    });
});

onMounted(() => {
    currentTab.value = route.query.tab || filteredTabs.value[0].id;
});
</script>

<style lang="scss" scoped>
.tabs-sticky {
    position: sticky;
    top: 0;
    z-index: 4;
    background: #f7f8fa;

    .tabs-wrapper {
        overflow-x: auto;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
        }

        div[role='tablist'] {
            display: inline-block;
            min-width: 100%;
            white-space: nowrap;
            border-bottom: 3px solid #ddd;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-left: 7px;
            padding-right: 7px;

            button {
                white-space: nowrap;
                box-sizing: border-box;
                border-bottom: 3px solid transparent;
                border-radius: 0;
                margin-bottom: -3px;
                font-size: 0.889rem;
                color: #717171;

                &:hover,
                &:focus {
                    color: #0071be;
                    border-bottom: 3px solid #ddd;
                }

                &.active {
                    color: #222;
                    border-bottom: 3px solid #0071be;
                }
            }
        }
    }
}
</style>
